module.exports = __webpack_public_path__ + "media/logos/bloomberg-logo-black-33d9b280.png";